var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex flex-col" }, [
    _vm.redirectTarget
      ? _c(
          "div",
          {
            staticClass:
              "sticky top-18 z-50 h-10 px-6 flex items-center flex-shrink-0 border-b border-slate-400 bg-slate-200"
          },
          [
            _c(
              "router-link",
              {
                staticClass: "flex items-center gap-2",
                attrs: { to: _vm.redirectTarget }
              },
              [
                _c("BlIcon", {
                  staticClass: "w-6 h-6",
                  attrs: { icon: "chevron-left" }
                }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  staticClass: "capitalize-first",
                  attrs: {
                    text:
                      _vm.redirectLabel ||
                      _vm.redirectTarget.replaceAll("/", " ")
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "w-full bg-slate-100 flex justify-center py-6" }, [
      _c(
        "div",
        {
          staticClass:
            "bg-pure-white rounded-3xl w-200 h-min relative border border-grey-200"
        },
        [
          _vm.pageLoading
            ? _c(
                "div",
                { staticClass: "h-200 w-200 grid place-items-center" },
                [_c("div", { staticClass: "blum-loader" })]
              )
            : _c("TabSession", {
                attrs: {
                  description:
                    "Here is detailed information about your therapist's session history.",
                  therapistName: _vm.user.name,
                  basePath: "/team/session-history/" + _vm.userId + "?",
                  userId: Number(_vm.userId)
                }
              })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bcfd150", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bcfd150","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/SessionHistory.vue
// module id = null
// module chunks = 